import { DialogProps, ButtonProps, Box } from '@mui/material';
import { useForm } from 'react-hook-form';

import { TextFormField } from 'components/FormFields';
import strings from 'constants/index';

import DeleteDialog from './DeleteDialog';

export interface DeleteWithReasonDialogProps extends DialogProps {
  entityName: string;
  onDelete: (reason: string) => Promise<void>;
  rules?: any;
  buttonProps?: ButtonProps;
  additionalMessage?: string;
}
const defaultValues = { Reason: '' };

const DeleteWithReasonDialog = ({
  onDelete,
  rules,
  additionalMessage,
  ...dialogProps
}: DeleteWithReasonDialogProps) => {
  const {
    getValues,
    control,
    handleSubmit,
    formState: { isDirty, isValid },
  } = useForm({
    defaultValues,
    mode: 'onChange',
  });

  return (
    <DeleteDialog
      onDelete={handleSubmit(data => onDelete(data.Reason))}
      additionalMessage={additionalMessage}
      buttonProps={{
        disabled: !isDirty || !isValid || !getValues().Reason || !getValues().Reason.trim(),
      }}
      {...dialogProps}
    >
      <Box sx={{ mt: 2 }}>
        <form noValidate>
          <TextFormField
            control={control}
            label={strings.note}
            name="Reason"
            fullWidth
            required
            rules={rules}
          />
        </form>
      </Box>
    </DeleteDialog>
  );
};

export default DeleteWithReasonDialog;
